// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__5T7T5","signatureBlock":"Footer_signatureBlock__3TVYp","signature":"Footer_signature__1V72E"};